import type { ProductImageEntry } from "./types";

export const COMPARE_DETAIL_CATALOGUE: readonly ProductImageEntry[] = [
  {
    id: "solution.compare-three",
    module: "Jämför",
    area: "solution",
    opens: "Jämför → Tre lösningar",
    setup: [
      "Välj Caire-rutten som referens och två sparade insatsflexprofiler för samma planeringsperiod",
      "Granska besökstilldelning, tidsfördelning och kvalitetsprofil",
    ],
    scenario: "S2",
    visual: { variant: 0 },
    text: {
      sv: {
        alt: "Tre sparade planeringsresultat jämförda med besökstilldelning, tidsfördelning och kvalitetsprofil",
        shows:
          "Jämför Caire-rutt med två insatsflexprofiler för samma planeringsperiod.",
        proves:
          "Vyn visar de tre sparade resultaten sida vid sida och jämför besökstilldelning, tidsfördelning och kvalitetsprofil med samma period som underlag.",
      },
      en: {
        alt: "Three saved planning results compared by visit assignment, time composition and quality profile",
        shows:
          "Compare Caire route with two visit-flexibility profiles for the same planning period.",
        proves:
          "The view places the three saved results side by side and compares visit assignment, time composition and quality profile for the same period.",
      },
    },
    use: ["pages/Plattform.tsx", "pages/Features/Analytics.tsx"],
  },
];
